/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_ProviderInputs */

const es_chat_tool_detail_provider = /** @type {(inputs: Chat_Tool_Detail_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const en_chat_tool_detail_provider = /** @type {(inputs: Chat_Tool_Detail_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Chat_Tool_Detail_ProviderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_provider = /** @type {((inputs?: Chat_Tool_Detail_ProviderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_ProviderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_provider(inputs)
	return en_chat_tool_detail_provider(inputs)
});
export { chat_tool_detail_provider as "chat.tool_detail.provider" }